angular
  .module 'filters'
  .filter 'taxRate', ->
    (rate) ->
      if rate.id
        "#{rate.name} (#{rate.percent}%)"
      else
        ''
